import { MppImageMimeTypes } from './enums';

export const DEFAULT_IMAGE_MIME_TYPES: MppImageMimeTypes[] = [
  MppImageMimeTypes.IMAGE_JPEG,
  MppImageMimeTypes.IMAGE_JPG,
  MppImageMimeTypes.IMAGE_PNG,
];
